import { render, staticRenderFns } from "./PreEnrichment.vue?vue&type=template&id=c08edfac&"
import script from "./PreEnrichment.vue?vue&type=script&lang=js&"
export * from "./PreEnrichment.vue?vue&type=script&lang=js&"
import style0 from "./PreEnrichment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports